import { useTranslate } from '@tolgee/react';
import { useEffect, useMemo, useRef } from 'react';
import { useInViewport, useRequest } from 'ahooks';
import { logisticsList } from 'services/api/conversation';
import { Badge, Space, Tag } from 'antd';

interface OrderStatusCellProps {
  leChatStatus: Conversation.Trade.LeChatTradeStatus;
  internalTradeId: number;
  reverseTag?: 'DISPUTE_IN_PROGRESS'[];
}

export const OrderStatusCell = (props: OrderStatusCellProps) => {
  const { leChatStatus, internalTradeId, reverseTag } = props;

  const trRef = useRef(null);
  const [inViewport] = useInViewport(trRef);

  const { t } = useTranslate();

  const { data, runAsync } = useRequest(
    () =>
      logisticsList({
        internal_trade_ids: `${internalTradeId}`,
      }),
    {
      manual: true,
    },
  );

  useEffect(() => {
    const noLogisticsStatus: Conversation.Trade.LeChatTradeStatus[] = [
      'LE_CHAT_UNKNOWN_TRADE',
      'LE_CHAT_NO_ORDER',
      'LE_CHAT_UNPAID',
    ];

    if (inViewport && !data && !noLogisticsStatus.includes(leChatStatus)) {
      runAsync();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inViewport, data]);

  const leChatLogisticsStatus = useMemo(() => data?.data?.data?.[0]?.leChatStatus, [data]);

  return (
    <Space direction="vertical">
      {reverseTag?.includes('DISPUTE_IN_PROGRESS') && (
        <Tag color="yellow">{t('scene.orderWorkspace.returnRefundTab.list.column.inDispute')}</Tag>
      )}
      <Tag color="gold" ref={trRef}>
        {t(`leChatStatus.${leChatStatus}`)}
      </Tag>
      {leChatLogisticsStatus && (
        <Badge color="gold" text={t(`leChatLogisticsStatus.${leChatLogisticsStatus}`)} />
      )}
    </Space>
  );
};
